module.exports = __webpack_public_path__ + "static/img/case1.15d68ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1.png
// module id = 29
// module chunks = 0